import request from './request'

export function listCrew(data) {
  return request.post('/mes/crews/list', data)
}
export function selectCrew() {
  return request.get('/mes/crews/select')
}
export function getCrew(id) {
  return request.get('/mes/crews/' + id)
}
export function saveCrew(data) {
  return request.post('/mes/crews', data)
}
export function updateCrew(data) {
  return request.post('/mes/crews/update', data)
}
export function deleteCrew(ids) {
  return request.post('/mes/crews/delete', ids)
}
